const DATE_MANUAL = 1;
const DATE_ACADEMIC_MAIN = 2;
const GRADE = 5;
const USER = 6;
const MAIN_GROUP = 7;
const DATE_FIRST_ACCESS = 8;
const DATE_CREATED_ENROLLMENT = 9;

const isByDateType = type => [DATE_MANUAL, DATE_ACADEMIC_MAIN, DATE_FIRST_ACCESS, DATE_CREATED_ENROLLMENT].includes(type);
const isByStudentType = type => [USER, MAIN_GROUP].includes(type);

export default {
  DATE_MANUAL,
  DATE_ACADEMIC_MAIN,
  GRADE,
  USER,
  MAIN_GROUP,
  DATE_FIRST_ACCESS,
  DATE_CREATED_ENROLLMENT,
  isByDateType,
  isByStudentType
};

